import React, { useState, useEffect } from 'react';
import { Phone, ArrowUp, Mail } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const FloatingActions = ({ onContactClick }) => {
  const settings = useSettings();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-24 right-6 flex flex-col gap-3 z-40">
      {/* Phone Button */}
      {settings.contact_phone ? (
        <a
          href={`tel:${settings.contact_phone}`}
          className="p-3 bg-teal-600 text-white rounded-full shadow-lg hover:bg-teal-700 hover:scale-110 transition-all"
          title={`Call ${settings.contact_phone}`}
          aria-label={`Call ${settings.contact_phone}`}
          data-testid="floating-call-btn"
        >
          <Phone className="w-5 h-5" />
        </a>
      ) : null}

      {/* Contact Button */}
      <button
        onClick={onContactClick}
        className="p-3 bg-purple-600 text-white rounded-full shadow-lg hover:bg-purple-700 hover:scale-110 transition-all"
        title="Contact us"
        aria-label="Contact us"
        data-testid="floating-contact-btn"
      >
        <Mail className="w-5 h-5" />
      </button>

      {/* Scroll to Top */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="p-3 bg-gray-700 dark:bg-gray-600 text-white rounded-full shadow-lg hover:bg-gray-800 dark:hover:bg-gray-500 hover:scale-110 transition-all animate-fade-in"
          title="Scroll to top"
          aria-label="Scroll to top"
          data-testid="floating-scroll-top-btn"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default FloatingActions;
